import { AxiosError, AxiosRequestConfig } from 'axios';
import { TAny } from '../types/blog';
import {
  CountryDefaultCurrencyRole,
  ICountryDetail,
  ICountryExchangeDetail,
  IDefaultCurrencyRoleUpdateResult,
  IUpdateCountry,
  IPrimaryCurrencyUpdateResult
} from '../types/countries';
import { apiGet, apiPost, apiPut } from './api';
const { REACT_APP_ORGANIZATION, REACT_APP_CATALOG, REACT_APP_SUBSCRIPTION } = process.env;

const countriesList = async (offeredService?: string): Promise<ICountryDetail[]> => {
  return apiGet<AxiosRequestConfig, ICountryDetail[]>(
    `${REACT_APP_ORGANIZATION}/country/listing${offeredService ? `?offeredService=${offeredService}` : ''}`
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const getAvailableCountries = async (): Promise<TAny> => {
  return apiGet<AxiosRequestConfig, TAny>(`${REACT_APP_ORGANIZATION}/country/iso/codes`)
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const updateCountryData = async (data: IUpdateCountry, id: number): Promise<string> => {
  return apiPut<AxiosRequestConfig, IUpdateCountry>(`${REACT_APP_ORGANIZATION}/country/update/${id}`, data)
    .then(resp => {
      const respEdit: string = resp;
      return respEdit;
    })
    .catch((error: AxiosError) => Promise.reject(error));
};

/** Actualiza la moneda primaria de un país. */
const updateCountryPrimaryCurrency = async (
  countryId: number,
  currencyId: number
): Promise<IPrimaryCurrencyUpdateResult> => {
  return apiPut<AxiosRequestConfig, { currencyId: number }>(
    `${REACT_APP_ORGANIZATION}/country/${countryId}/primary-currency`,
    { currencyId }
  )
    .then(resp => Promise.resolve(resp))
    .catch((error: AxiosError) => Promise.reject(error));
};


/** Actualiza la moneda por defecto para registro de costos del país. */
const updateCountryDefaultCurrencyRole = async (
  countryId: number,
  defaultCurrencyRole: CountryDefaultCurrencyRole
): Promise<IDefaultCurrencyRoleUpdateResult> => {
  return apiPut<AxiosRequestConfig, { defaultCurrencyRole: CountryDefaultCurrencyRole }>(
    `${REACT_APP_ORGANIZATION}/country/${countryId}/default-currency-role`,
    { defaultCurrencyRole }
  )
    .then(resp => Promise.resolve(resp))
    .catch((error: AxiosError) => Promise.reject(error));
};

const createCountry = async (formData: TAny) => {
  return apiPost<AxiosRequestConfig, TAny>(`${REACT_APP_ORGANIZATION}/country`, formData)
    .then(resp => {
      const respEdit: string = resp;
      return respEdit;
    })
    .catch((error: AxiosError) => Promise.reject(error));
};

const getCountriesOpenForSelling = async (): Promise<any> => {
  return apiGet<AxiosRequestConfig, any>(`${REACT_APP_CATALOG}exchange`)
    .then(resp => Promise.resolve(resp))
    .catch((error: AxiosError) => Promise.reject(error));
};

const getCountriesOpenForSellingWhitProviders = async (): Promise<ICountryExchangeDetail[]> => {
  return apiGet<AxiosRequestConfig, ICountryExchangeDetail[]>(`${REACT_APP_CATALOG}exchange/with-providers`)
    .then(resp => Promise.resolve(resp))
    .catch((error: AxiosError) => Promise.reject(error));
};

const getCountryWarehouseData = async (): Promise<ICountryDetail[]> => {
  return apiGet<AxiosRequestConfig, ICountryDetail[]>(`${REACT_APP_SUBSCRIPTION}/country/warehouse`)
    .then(resp => Promise.resolve(resp))
    .catch((error: AxiosError) => Promise.reject(error));
};

export {
  countriesList,
  updateCountryData,
  updateCountryPrimaryCurrency,
  updateCountryDefaultCurrencyRole,
  createCountry,
  getAvailableCountries,
  getCountriesOpenForSelling,
  getCountriesOpenForSellingWhitProviders,
  getCountryWarehouseData
};
